export default window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  function(cb) {
    setTimeout(cb, 40);
  };
